/**
 * Yū — nav image loader.
 *
 * Images inside the mega menu are marked `loading="lazy"` so they cost
 * nothing until a shopper actually opens the menu. But the panel is
 * display:none at parse time, and the browser's lazy loader does not
 * reliably re-evaluate those images when the panel is later revealed —
 * measured on the preview themes, every nav image stayed at
 * naturalWidth 0 even after the dropdown was open and painted.
 *
 * So: when a mega dropdown opens, upgrade any still-unloaded lazy image
 * in it to eager and re-assign its src to kick off the fetch. This keeps
 * the "don't download until opened" benefit and fixes the empty tiles.
 *
 * Delegated throughout — the theme re-renders the header after load, which
 * discards element-bound listeners.
 */
(function () {
  'use strict';

  var MEGA = '.site-nav--is-megamenu';

  function upgrade(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img[loading="lazy"]');

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) continue;
      if (img.getAttribute('data-yu-eager') !== null) continue;

      /* Skip anything inside a hidden panel — the goal card panels are
         rendered up front but must not download until one is opened. */
      if (typeof img.closest === 'function' && img.closest('[hidden]')) continue;

      img.setAttribute('data-yu-eager', '');
      img.setAttribute('loading', 'eager');

      /* Re-assigning src restarts the fetch for an image the lazy loader
         has already skipped. srcset needs the same nudge when present. */
      var srcset = img.getAttribute('srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      var src = img.getAttribute('src');
      if (src) img.setAttribute('src', src);
    }
  }

  /* <details> fires `toggle` when it opens. Captured, because the event
     does not bubble. */
  document.addEventListener(
    'toggle',
    function (event) {
      var el = event.target;
      if (!el || el.tagName !== 'DETAILS' || !el.open) return;
      upgrade(el);
    },
    true
  );

  /* Belt and braces: a hover-opened menu whose theme toggles classes rather
     than the [open] attribute would never fire `toggle`. */
  document.addEventListener('mouseover', function (event) {
    var el = event.target;
    if (!el || typeof el.closest !== 'function') return;
    var mega = el.closest(MEGA);
    if (mega) upgrade(mega);
  });

  document.addEventListener('focusin', function (event) {
    var el = event.target;
    if (!el || typeof el.closest !== 'function') return;
    var mega = el.closest(MEGA);
    if (mega) upgrade(mega);
  });

  /* Exposed so the card panels can pull their images in the moment they are
     shown, rather than waiting for the next mega-menu open. */
  window.yuNavUpgradeImages = upgrade;
})();
